/* Calentadores Goliat · portada estilo monopo.vn (viene de web/piloto-monopo.html).
   Cada sección carga este archivo; la guarda hace que corra una sola vez. */
(() => {
  if (window.gmIniciado) return;
  window.gmIniciado = true;

  const raiz = document.documentElement;
  // gm-anim lo pone el hero solo con movimiento y fuera del editor
  const movimiento = raiz.classList.contains('gm-anim');

  // El hero descuenta la cabecera de Dawn (barras de anuncio + encabezado)
  const medirCabecera = () => {
    let alto = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach((s) => { alto += s.offsetHeight; });
    raiz.style.setProperty('--gm-cabecera', `${alto}px`);
  };
  medirCabecera();
  addEventListener('resize', medirCabecera);

  // rAF no corre en pestañas en segundo plano: el temporizador asegura que el contenido nunca quede oculto
  const mostrar = () => raiz.classList.add('gm-listo');
  requestAnimationFrame(mostrar);
  setTimeout(mostrar, 300);

  // Selector de diseño: actualiza el enlace y el texto del botón de compra
  const boton = document.getElementById('comprar-seleccion');
  const texto = document.getElementById('comprar-texto');
  if (boton && texto) document.querySelectorAll('input[name="gm-diseno"]').forEach((r) => r.addEventListener('change', () => {
    boton.href = r.value;
    texto.textContent = `Comprar ${r.dataset.nombre} · ${r.dataset.precio}`;
  }));

  // Aparición al entrar en pantalla: cada hijo de [data-aparecer] sube y se escalona 0.1 s con los que entran a la vez
  const hijos = document.querySelectorAll('.gm [data-aparecer] > *');
  if (movimiento && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entradas) => {
      entradas.filter((e) => e.isIntersecting).forEach((e, i) => {
        e.target.style.transitionDelay = `${i * .1}s`;
        e.target.classList.add('visto');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    hijos.forEach((h) => io.observe(h));
  } else hijos.forEach((h) => h.classList.add('visto'));

  // Cursor de monopo: círculo con flecha que sigue al ratón sobre las fotos de los modelos
  const cursor = document.querySelector('.gm .cursor');
  if (cursor && movimiento && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    let x = 0, y = 0, cx = 0, cy = 0, girando = false;
    const seguir = () => {
      cx += (x - cx) * .18; cy += (y - cy) * .18;
      cursor.style.translate = `${cx}px ${cy}px`;
      girando = Math.abs(x - cx) + Math.abs(y - cy) > .5;
      if (girando) requestAnimationFrame(seguir);
    };
    addEventListener('pointermove', (e) => {
      x = e.clientX; y = e.clientY;
      if (!girando) { girando = true; requestAnimationFrame(seguir); }
    }, { passive: true });
    document.querySelectorAll('.gm .proyecto__imagen').forEach((a) => {
      a.addEventListener('pointerenter', () => cursor.classList.add('activo'));
      a.addEventListener('pointerleave', () => cursor.classList.remove('activo'));
    });
  }

  // Lente: se mueve un 20% más lento que el scroll
  const lente = document.querySelector('.gm .hero__lente');
  if (lente && movimiento) addEventListener('scroll', () => {
    lente.style.setProperty('--parallax', `${Math.min(scrollY, innerHeight) * .2}px`);
  }, { passive: true });

  // Luz líquida: senos superpuestos que deforman el plano, a baja resolución y escalado por CSS
  const lienzo = document.querySelector('.gm .hero__liquido canvas');
  const gl = lienzo && lienzo.getContext('webgl', { antialias: false, alpha: false });
  if (!gl) return;

  const vert = 'attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
  const frag = `precision mediump float;
    uniform vec2 r; uniform float t; uniform vec2 m;
    void main(){
      vec2 uv=gl_FragCoord.xy/r; vec2 p=(gl_FragCoord.xy-.5*r)/r.y*2.4;
      p+=(m-.5)*.6;
      float s=t*.18;
      for(int i=1;i<7;i++){float k=float(i);
        p+=vec2(.55/k*sin(k*p.y+s+.3*k), .55/k*sin(k*p.x+s+.3*k+1.6));}
      float b=.5+.5*sin(1.8*p.x+1.4*p.y);
      float g=.5+.5*cos(1.2*p.y-.8*p.x);
      vec3 negro=vec3(.03,.026,.024), vino=vec3(.36,.09,.06), cobre=vec3(.70,.36,.14),
           dorado=vec3(.85,.68,.32), marfil=vec3(.96,.92,.84);
      vec3 c=mix(negro,vino,smoothstep(.3,.9,g));
      c=mix(c,cobre,pow(b,2.)*g*.9);
      c=mix(c,dorado,pow(b,6.)*smoothstep(.2,.7,g));
      c=mix(c,marfil,pow(b,22.)*smoothstep(.4,.9,g)*.5);
      float v=smoothstep(1.2,.2,length(uv-.5)*1.5);
      gl_FragColor=vec4(c*mix(.5,1.,v),1.);
    }`;
  const sombreador = (tipo, src) => { const s = gl.createShader(tipo); gl.shaderSource(s, src); gl.compileShader(s); return s; };
  const prog = gl.createProgram();
  gl.attachShader(prog, sombreador(gl.VERTEX_SHADER, vert));
  gl.attachShader(prog, sombreador(gl.FRAGMENT_SHADER, frag));
  gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
  gl.useProgram(prog);
  gl.bindBuffer(gl.ARRAY_BUFFER, gl.createBuffer());
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
  gl.enableVertexAttribArray(0);
  gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0);
  const uR = gl.getUniformLocation(prog, 'r'), uT = gl.getUniformLocation(prog, 't'), uM = gl.getUniformLocation(prog, 'm');

  const ESCALA = .35; // el desenfoque sale gratis al escalar
  const medir = () => {
    lienzo.width = Math.ceil(lienzo.clientWidth * ESCALA);
    lienzo.height = Math.ceil(lienzo.clientHeight * ESCALA);
    gl.viewport(0, 0, lienzo.width, lienzo.height);
  };
  medir();
  addEventListener('resize', medir);

  // El líquido sigue al puntero con retraso
  const raton = { x: .5, y: .5 }, meta = { x: .5, y: .5 };
  addEventListener('pointermove', (e) => { meta.x = e.clientX / innerWidth; meta.y = 1 - e.clientY / innerHeight; }, { passive: true });

  let visible = true, cuadro;
  const dibujar = (ms) => {
    raton.x += (meta.x - raton.x) * .03; raton.y += (meta.y - raton.y) * .03;
    gl.uniform2f(uR, lienzo.width, lienzo.height);
    gl.uniform1f(uT, 12 + ms / 1000);
    gl.uniform2f(uM, raton.x, raton.y);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
    if (movimiento && visible && !document.hidden) cuadro = requestAnimationFrame(dibujar);
  };
  const reanudar = () => { cancelAnimationFrame(cuadro); cuadro = requestAnimationFrame(dibujar); };
  new IntersectionObserver(([e]) => { visible = e.isIntersecting; if (visible) reanudar(); }).observe(lienzo);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) reanudar(); });
  lienzo.classList.add('activo');
  reanudar();
})();